import { Modal as ModalMantine } from '@mantine/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import classes from './modal.module.css';

const Modal = (props) => {
  const {
    opened,
    close,
    title,
    children,
    showClose = true,
    footer,
    showFooterBackground = false,
    showAvatarBackground = false,
    avatar,
    size,
  } = props;

  const footerClasses = clsx(classes.footer, showFooterBackground && classes.background);
  const avatarClasses = clsx(classes.avatar, showAvatarBackground && classes.background);
  const bodyElement = <ModalMantine.Body>{children}</ModalMantine.Body>;
  const footerElement = footer ? <div className={footerClasses}>{footer}</div> : null;
  const avatarElement = avatar ? <div className={avatarClasses}>{avatar}</div> : null;
  const titleElement = title ? <ModalMantine.Title>{title}</ModalMantine.Title> : null;
  const closeElement = showClose ? <ModalMantine.CloseButton /> : null;
  const headerElement = (titleElement || closeElement)
    ? <ModalMantine.Header>
      {titleElement}
      {closeElement}
    </ModalMantine.Header>
    : null;

  return (
    <ModalMantine.Root opened={opened} onClose={close} size={size}>
      <ModalMantine.Overlay />
      <ModalMantine.Content pt={0}>
        <div className={classes.body}>
          <div>
            {headerElement}
            {bodyElement}
            {footerElement}
          </div>
          <div>
            {avatarElement}
          </div>

        </div>
      </ModalMantine.Content>
    </ModalMantine.Root>
  );
};

Modal.propTypes = {
  opened: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.any,
  showClose: PropTypes.bool,
  footer: PropTypes.any,
  showFooterBackground: PropTypes.bool,
  showAvatarBackground: PropTypes.bool,
  avatar: PropTypes.node,
  size: PropTypes.string,
  disableClose: PropTypes.bool,
};

export default Modal;
